export function scrollTo ({ mobile, desktop, ref, vm, hasOverlay, hasPermisoSolicitud }) {
  vm.$nextTick(() => {
    if (hasOverlay) {
      ref = ref.querySelector('.card')
    }
    if (hasPermisoSolicitud) {
      ref = ref.querySelector('.close')
    }

    let offsetTop = getOffsetTop(ref);

    let contenedor = document.getElementsByClassName('contenedor')[0];

    // Si no es modo mobile, contenedor no puede scrollear, tenemos que cambiar al html
    if (window.getComputedStyle(contenedor).overflow !== 'auto') {
      contenedor = document.documentElement;
      offsetTop = offsetTop + desktop;
    } else {
      offsetTop = offsetTop + mobile
    }

    contenedor.scroll({
      top: offsetTop, // Adjusts the position to be 10px above the element
      behavior: 'smooth'
    });
  });
}

function getOffsetTop (element) {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}



// WEBPACK FOOTER //
// ./src/util/scroll.js